import { render } from "./CreateUserAccount.vue?vue&type=template&id=0e5c3259&scoped=true"
import script from "./CreateUserAccount.vue?vue&type=script&lang=js"
export * from "./CreateUserAccount.vue?vue&type=script&lang=js"

import "./CreateUserAccount.vue?vue&type=style&index=0&id=0e5c3259&scoped=true&lang=css"

import exportComponent from "/home/gp/git/git.glitchedpolygons.ch/locales.glitchedpolygons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e5c3259"]])

export default __exports__